import { UserConnectedComponent } from '$components/header/user-connected/user-connected.component';
import { AuthService } from '$services/auth/auth.service';
import { EventBusService } from '$services/auth/event/event-bus.service';
import { EventData } from '$services/auth/event/event.class';
import { StorageService } from '$services/auth/storage.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent implements OnInit {
  loginForm!: FormGroup
  error?: string
  isLoggedIn = false
  isLoginFailed = false
  errorMessage = ''
  roles: string[] = []
  success_message: any;
  failure_message: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly snackBar: MatSnackBar,
    private readonly translateService: TranslateService,
    private readonly dialogRef: MatDialogRef<UserConnectedComponent>,
    private readonly eventBusService:EventBusService,
    private readonly router:Router
  ) {
    this.success_message = this.translateService.instant('login.success');
    this.failure_message = this.translateService.instant('login.error');
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: [null],
      password: [null],
    });
  }

  onSubmit(e: MouseEvent): void {
    e.preventDefault();

    console.log('login ...')

    try {
      this.authService.login(this.loginForm.value).subscribe({
        next: data => {

          console.log('login success !')
          this.storageService.saveUser(data);
          this.isLoginFailed = false;
          this.isLoggedIn = true;
          this.roles = this.storageService.getUser().roles;

          this.snackBar.open(this.success_message, undefined, {
            duration: 1000,
            verticalPosition: 'top',
            panelClass: ['bg-green'],
          })

          this.dialogRef.close('login')
          this.eventBusService.emit(new EventData('login', null));

          this.reloadCurrentRoute()
        },
        error: err => {
          this.errorMessage = 'login invalid';
          this.isLoginFailed = true;
          this.snackBar.open(this.failure_message, 'ok', {
            verticalPosition: 'bottom',
            panelClass: ['bg-red'],
          })
        }
      });
    } catch (err: any) {
      this.error = err.message;
    }
  }
  cancel() {
    this.dialogRef.close('cancel')
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      });
  }
}
